import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalProxyComponent } from './global-proxy.component';
import {
  BzgButtonModule,
  BzgCheckboxModule, BzgIconModule,
  BzgInputModule,
  BzgModalModule,
  BzgPasswordModule,
  BzgSwitchModule,
  BzgTabsModule, BzgTextareaModule
} from 'bz-genome-angular';
import {TranslateModule} from '@ngx-translate/core';
import { ProxyobjectComponent } from './proxyobject/proxyobject.component';
import {FormsModule} from '@angular/forms';
import {ProxyObjectComponent} from './proxy-object/proxy-object.component';

@NgModule({
  declarations: [GlobalProxyComponent, ProxyObjectComponent],
  imports: [
    CommonModule,
    FormsModule,
    BzgModalModule,
    BzgButtonModule,
    BzgTabsModule,
    BzgSwitchModule,
    BzgInputModule,
    BzgPasswordModule,
    BzgCheckboxModule,
    BzgIconModule,
    BzgPasswordModule,
    BzgTextareaModule,
    TranslateModule
  ]
})
export class GlobalProxyModule { }
